
import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Space } from 'antd';
import { useTimeZone } from '@/config/timeZone';
import HeaderDropdown from '../HeaderDropdown';
import { GlobalOutlined } from '@ant-design/icons';
import { converOptionsAntdToMap } from '@/common/functions';

type TimeZoneDropdownProps = {
  store: {
    timeZone: string,
    setTimeZone: Function,
  }
};

const TimeZoneDropdown = observer(({ store } : TimeZoneDropdownProps) => {

  const timeZoneList = useTimeZone();
  const timeZoneMap = converOptionsAntdToMap(timeZoneList);

  const handleClick = ({ key } : { key : string }) => {
    store.setTimeZone(key);
  };

  return (
    <HeaderDropdown
      menu={{
        items: (timeZoneList||[])
          .map((item:any) => (
            { key:item?.value, label: item?.label }
          )),
        onClick: handleClick,
        selectedKeys: [store.timeZone]
      }}
    >
      <Space className="action" size={4}>
        <GlobalOutlined />
        <span style={{ whiteSpace: 'nowrap' }}>
          {timeZoneMap[store.timeZone] || store.timeZone || ''}
        </span>
      </Space>
    </HeaderDropdown>
  );
});

export default TimeZoneDropdown;
